module.exports = __webpack_public_path__ + "img/icon_sort_header.21625a04.svg";